import { render, staticRenderFns } from "./renewal.vue?vue&type=template&id=e2dee5b8&"
import script from "./renewal.vue?vue&type=script&lang=ts&"
export * from "./renewal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports